import { Box, Grid, Skeleton, Stack } from '@atgfr8/atg-ui-tailwind';
import { Component } from 'solid-js';

const EDITabSkeleton: Component = () => {
  return (
    <Box style={{ 'flex-grow': 1 }}>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rectangular" width="100%" height={500} />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>
            <Skeleton variant="rectangular" width="100%" height={50} />
            <Skeleton variant="rectangular" width="100%" height={250} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EDITabSkeleton;
